import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/KishPortInfo`;

const KishPortInfo = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAllUsedPromoCodeByUser: (params) => {
    const url = `${baseServiceUrl}/getAllUsedPromoCodeByUser`;
    return ServiceApi.get(url, { params });
  },

  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    // console.log("url==========", id);

    return ServiceApi.get(url);
  },
  getAllPromoCategory: () => {
    const url = `${baseServiceUrl}/getAllPromoCategory`;
    return ServiceApi.get(url);
  },
  getKishPortInfoById: (params) => {
    // console.log("params==========", params);
    const url = `${baseServiceUrl}/getKishPortInfoById?id=` + params;
    // console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  addOrEditKishPortInfo: (params) => {
    // console.log("params==========", params);
    const url = `${baseServiceUrl}/addOrEditKishPortInfo`;
    // console.log("url==========", url);
    return ServiceApi.post(url, params);
  },
  getNewPromoCodeQuery: () => {
    const url = `${baseServiceUrl}/getNewPromoCodeQuery`;
    return ServiceApi.get(url);
  },
  updateKishPortInfoStatus: (params) => {
    // console.log("params==========",params);
    const url = `${baseServiceUrl}/updateKishPortInfoStatus`;
    // console.log("url==========",url);
    return ServiceApi.put(url, params);
  },
};

export default KishPortInfo;
